var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('picture',{staticClass:"component-thumbnail",class:{ active: _vm.isActive },on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"image",attrs:{"width":"200","height":"100","src":_vm.src,"alt":_vm.alt}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }